




































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { roleDataPermissionList, saveDataPermission } from '@/api/systemRoleSetting.js';

const typeMap = {
  1: '普通项目',
  2: '绝密项目',
  3: '专利项目'
};
const phaseMap = {
  1: '发展期信息',
  2: '融资期信息(除最新轮外)',
  3: '融资期信息(最新轮)'
};
const intoMap = {
  0: '搜索可见',
  2: '列表页可见',
  1: '可点击进入'
};
const authTypeList = ['see', 'download'];
const fileTypeAuthType = {
  4: 'upload',
  0: 'see',
  1: 'download'
};
const fileTypeCurrencyType = {
  1: 'CNY',
  2: 'USD',
  3: 'CNY&USD',
  0: '-'
};
const fileTypeAllType = {
  '01': 'seeCNY',
  '02': 'seeUSD',
  '03': 'seeCNY&USD',
  '11': 'downloadCNY',
  '12': 'downloadUSD',
  '13': 'downloadCNY&USD',
  '40': 'upload-'
};
// const fileTypeAuthType = ['see', 'download'];
const powerList = ['allPower', 'lawPower'];
const fileCollectColmuns = [
  {
    align: 'center',
    width: '300px',
    customRender: data => {
      return data.name;
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'fileCollectPower' }
  }
];

const fileRetrievalColmuns = [
  {
    align: 'center',
    width: '300px',
    customRender: data => {
      return data.name;
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'fileRetrievalPower' }
  }
];

const financingStageColmuns = [
  {
    align: 'center',
    width: '300px',
    customRender: data => {
      return data.name;
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'financingStagePower' }
  }
];

const companyCurrencyColmuns = [
  {
    align: 'center',
    width: '300px',
    customRender: data => {
      return data.name;
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'companyCurrencyPower' }
  }
];
const companyTeamColmuns = [
  {
    align: 'center',
    width: '300px',
    customRender: data => {
      return data.name;
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'companyTeamPower' }
  }
];

const lpdataRangeColmns = [
  {
    align: 'center',
    width: '300px',
    title: '数据范围',
    customRender: data => {
      return '全量LP';
    }
  },
  {
    title: '全部权限',
    align: 'center',
    scopedSlots: { customRender: 'lpRangePower' }
  }
];
@Component({})
class DataPower extends Vue {
  loading: boolean = false;
  periodPowerColumns: any[] = [];
  companyState: any[] = [];
  statelist: any[] = [];
  dataPermissionIdList: any[] = [];
  resourceType: any[] = [];
  unifySetting: boolean = true;
  resourceTypeColumns: any[] = [];
  resourcelist: any[] = [];
  checkedData: any[] = [];
  fileTypeColumns: any[] = [];
  fundFileColumns: any[] = [];
  fileType: any[] = [];
  fundfileType: any[] = [];
  authTypeList: any[] = authTypeList;
  fileTypeAuthType: object = fileTypeAuthType;
  fileTypeAllType: Object = fileTypeAllType;
  fundStructureColumns: any[] = [];
  fundStructure: any[] = [];
  powerList: any[] = powerList;
  fileTypeMap: Object = {};
  fundTypeMap: Object = {};
  resourceMap: Object = {};
  resourceStateMap: Object = {};
  companyStateMap: Object = {};
  fundStructureMap: Object = {};
  fileCollectColmuns: any[] = fileCollectColmuns;
  fileCollectData: any[] = [];
  fileRetrievalColmuns: any[] = fileRetrievalColmuns;
  fileRetrievalData: any[] = [];
  financingStageColmuns: any[] = financingStageColmuns;
  financingStageData: any[] = [];
  companyCurrencyColmuns: any[] = companyCurrencyColmuns;
  companyTeamColmuns: any[] = companyTeamColmuns;
  companyCurrencyData: any[] = [];
  companyTeamData: any[] = [];
  currentKey: String = '1';
  lpdataRangeColmns: any[] = lpdataRangeColmns;
  lpdataRangeData: any[] = [];

  mounted() {
    this.getList();
  }

  get roleId() {
    return this.$route.query.id;
  }

  get name() {
    return this.$route.query.name;
  }

  async getList() {
    this.loading = true;
    try {
      this.loading = false;
      let res = await roleDataPermissionList(this.roleId);
      if (res.code === 200) {
        let companyStateList = res.data.companyState;
        this.getCompanyStateMap(companyStateList);
        console.log('this.companyStateMap', this.companyStateMap);
        console.log('companyStateList', companyStateList);
        this.generatCompanyStateList(companyStateList, 1);
        this.generatCompanyStateList(companyStateList, 2);
        this.generatCompanyStateList(companyStateList, 3);
        console.log('this.companyState', this.companyState);
        this.getPeriodPowerColumns();
        this.generateResourceTypeList(res.data.resourceType);
        this.getResourceTypeColumns();
        this.generateFileTypeList(res.data.fileType);
        this.getFileTypeColumns();
        this.generateFundFileTypeList(res.data.fundFileType);
        this.getFundFileTypeColumns();
        this.getFundStructureColumns();
        this.generateFundStructureList(res.data.fundStructure);
        this.fileCollectData = [res.data.isolated[0]];
        this.lpdataRangeData = [res.data.isolated[1]];
        this.fileRetrievalData = res.data.fileRetrieval;
        this.financingStageData = res.data.financingStage;
        this.companyCurrencyData = res.data.companyCurrencyType;
        this.companyTeamData = res.data.companyTeamType;
      }
    } catch (err) {
      console.log(err);
    }
  }

  tabChange(key) {
    this.currentKey = key;
  }

  getCompanyStateMap(data) {
    let list = data
      .filter(e => {
        return e.phase === 0 && e.typeId === 1;
      })
      .sort((a, b) => {
        return a.sort - b.sort;
      });
    list.forEach(e => {
      if (!this.companyStateMap.hasOwnProperty(e.stateId)) {
        this.companyStateMap[e.stateId] = e.stateName;
        this.statelist.push(e.stateId);
      }
    });
  }

  generatCompanyStateList(companyStateList, typeId) {
    this.companyState.push({ typeId: typeId });
    let isSee = { into: 0 };
    isSee = this.generatCompanyStage(companyStateList, isSee, typeId, 0);
    this.companyState.push(isSee);
    let listSee = { into: 2 };
    listSee = this.generatCompanyStage(companyStateList, listSee, typeId, 4);
    this.companyState.push(listSee);
    this.companyState.push({ into: 1 });
    let develop = { phase: 1 };
    develop = this.generatCompanyStage(companyStateList, develop, typeId, 1);
    this.companyState.push(develop);
    let finance = { phase: 2 };
    finance = this.generatCompanyStage(companyStateList, finance, typeId, 2);
    this.companyState.push(finance);
    let financeNewest = { phase: 3 };
    financeNewest = this.generatCompanyStage(companyStateList, financeNewest, typeId, 3);
    this.companyState.push(financeNewest);
  }

  generatCompanyStage(list, obj, typeId, phase) {
    list.forEach(e => {
      if (e.typeId === typeId && e.phase === phase) {
        if (obj.hasOwnProperty('stage')) {
          obj['stage'].push(e);
        } else {
          obj['stage'] = [{ ...e }];
        }
      }
    });
    if (obj['stage']) {
      obj['stage'] = obj['stage'].sort((a, b) => {
        return a.sort - b.sort;
      });
    }
    return obj;
  }

  getPeriodPowerColumns() {
    this.periodPowerColumns = [
      {
        title: '项目标签',
        align: 'center',
        dataIndex: 'typeId',
        customRender: (typeId, row, index) => {
          return typeMap[typeId];
        }
      },
      {
        title: '可见/可进入权限',
        align: 'center',
        dataIndex: 'into',
        customRender: (into, row, index) => {
          if (into === 0 || into === 1 || into === 2) {
            return intoMap[into];
          }
          return '';
        }
      },
      {
        title: '融资期/发展期权限',
        align: 'center',
        dataIndex: 'phase',
        customRender: (phase, row, index) => {
          if (phase !== 0 && phase !== 4) {
            return phaseMap[phase];
          }
          return '';
        }
      }
    ];
    this.statelist.forEach(e => {
      for (let key in this.companyStateMap) {
        if (e.toString() === key) {
          this.periodPowerColumns.push({ title: this.companyStateMap[key], align: 'center', scopedSlots: { customRender: key } });
        }
      }
    });
  }

  generateResourceTypeList(data) {
    // 列sort
    let list = data.sort((a, b) => {
      return a.sort - b.sort && a.colSort - b.colSort;
    });
    list.forEach(e => {
      if (!this.resourceStateMap.hasOwnProperty(e.stateId)) {
        this.resourceStateMap[e.stateId] = e.stateName;
        this.resourcelist.push(e.stateId);
      }
    });

    list.forEach(e => {
      if (!this.resourceMap.hasOwnProperty(e.typeId)) {
        this.resourceMap[e.typeId] = e.resourceName;
      }
    });

    let resourceType: any[] = [];
    for (let key in this.resourceMap) {
      resourceType.push({ typeId: key });
    }
    data.forEach(e => {
      let typeId = e.typeId;
      let item = e;
      resourceType.forEach(e => {
        if (e.typeId === typeId.toString()) {
          if (e.hasOwnProperty('stage')) {
            e['stage'].push(item);
          } else {
            e['stage'] = [{ ...item }];
          }
          if (e.hasOwnProperty('checked')) {
            if (item.checked === true) {
              e['checked'].push(item);
            }
          } else {
            if (item.checked === true) {
              e['checked'] = [{ ...item }];
            }
          }
        }
      });
    });
    resourceType.forEach(e => {
      if (e.stage) {
        e['stage'].sort((a, b) => {
          return a.sort - b.sort;
        });
        e['colSort'] = e['stage'][0].colSort;
      }
      e['indeterminate'] = false;
      if (e.checked && e.checked.length === this.resourcelist.length) {
        e['checkAll'] = true;
      } else {
        e['checkAll'] = false;
      }
    });
    // 按colSort排序
    this.resourceType = resourceType.sort((a, b) => {
      return a.colSort - b.colSort;
    });
  }

  getResourceTypeColumns() {
    this.resourceTypeColumns = [
      {
        title: '项目资源模块',
        // align: 'center',
        dataIndex: 'typeId',
        width: '300px',
        customRender: (typeId, row, index) => {
          return this.resourceMap[typeId];
        }
      },
      {
        title: '统一设置',
        align: 'center',
        scopedSlots: { customRender: 'setting' }
      }
    ];
    this.resourcelist.forEach(e => {
      for (let key in this.resourceStateMap) {
        if (e.toString() === key) {
          this.resourceTypeColumns.push({ title: this.resourceStateMap[key], align: 'center', scopedSlots: { customRender: key } });
        }
      }
    });
  }

  generateFileTypeList(data) {
    data.sort((a, b) => {
      return a.sort - b.sort;
    });
    data.forEach(e => {
      if (!this.fileTypeMap.hasOwnProperty(e.typeId)) {
        this.fileTypeMap[e.typeId] = e.fileTypeName;
      }
      // 加了一个allType字段,把authType和currencyType合起来了,当成新的列标识
      // 详见fileTypeColumns & fileTypeAllType
      e['allType'] = e.authType.toString() + (e.currencyType ? e.currencyType.toString() : '0');
    });
    let fileType: any[] = [];
    for (let key in this.fileTypeMap) {
      fileType.push({ typeId: key });
    }
    data.forEach(e => {
      let typeId = e.typeId;
      let item = e;
      fileType.forEach(e => {
        if (typeId.toString() === e.typeId) {
          if (e['allType']) {
            e['allType'] = Object.assign(e['allType'], { [item.allType]: item });
          } else {
            e['allType'] = { [item.allType]: item };
          }
        }
      });
    });
    this.fileType = fileType;
  }

  getFileTypeColumns() {
    this.fileTypeColumns = [
      {
        title: '项目文档类型',
        align: 'center',
        dataIndex: 'typeId',
        width: '100px',
        customRender: typeId => {
          return this.fileTypeMap[typeId];
        }
      },
      {
        title: '可上传',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'upload-' }
      },
      {
        title: '可查看(人民币项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'seeCNY' }
      },
      {
        title: '可查看(美元项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'seeUSD' }
      },
      {
        title: '可查看(人民币及美元项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'seeCNY&USD' }
      },
      {
        title: '可下载(人民币项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'downloadCNY' }
      },

      {
        title: '可下载(美元项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'downloadUSD' }
      },
      {
        title: '可下载(人民币及美元项目)',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'downloadCNY&USD' }
      }
    ];
  }

  generateFundFileTypeList(data) {
    data.sort((a, b) => {
      return a.sort - b.sort;
    });
    data.forEach(e => {
      if (!this.fundTypeMap.hasOwnProperty(e.typeId)) {
        this.fundTypeMap[e.typeId] = e.fileTypeName;
      }
    });
    let fundfileType: any[] = [];
    for (let key in this.fundTypeMap) {
      fundfileType.push({ typeId: key });
    }
    data.forEach(e => {
      let typeId = e.typeId;
      let item = e;
      fundfileType.forEach(e => {
        if (typeId.toString() === e.typeId) {
          if (e.hasOwnProperty('authType')) {
            e['authType'].push(item);
          } else {
            e['authType'] = [{ ...item }];
          }
        }
      });
    });
    this.fundfileType = fundfileType;
  }

  getFundFileTypeColumns() {
    this.fundFileColumns = [
      {
        title: '基金文档类型',
        align: 'center',
        dataIndex: 'typeId',
        width: '300px',
        customRender: typeId => {
          return this.fundTypeMap[typeId];
        }
      },
      {
        title: '可查看',
        align: 'center',
        width: '150px',
        scopedSlots: { customRender: 'see' }
      },
      {
        title: '可下载',
        align: 'center',
        scopedSlots: { customRender: 'download' }
      }
    ];
  }

  generateFundStructureList(data) {
    data.forEach(e => {
      if (!this.fundStructureMap.hasOwnProperty(e.typeId)) {
        this.fundStructureMap[e.typeId] = e.dealTypeName;
      }
    });
    let fundStructure: any[] = [];
    for (let key in this.fundStructureMap) {
      fundStructure.push({ typeId: key });
    }
    data.forEach(e => {
      let typeId = e.typeId;
      let item = e;
      fundStructure.forEach(e => {
        if (typeId.toString() === e.typeId) {
          if (e.hasOwnProperty('authType')) {
            e['authType'].push(item);
          } else {
            e['authType'] = [{ ...item }];
          }
        }
      });
    });
    this.fundStructure = fundStructure;
  }

  getFundStructureColumns() {
    this.fundStructureColumns = [
      {
        align: 'center',
        dataIndex: 'typeId',
        width: '300px',
        customRender: typeId => {
          return this.fundStructureMap[typeId];
        }
      },
      {
        title: '全部权限',
        align: 'center',
        scopedSlots: { customRender: 'allPower' }
      },
      {
        title: '权限跟随交易系统（原法务系统）',
        align: 'center',
        scopedSlots: { customRender: 'lawPower' }
      }
    ];
  }

  changeSetting(data) {
    data.checkAll = !data.checkAll;
    data.checked = [];
    if (data.checkAll === true) {
      data.stage.forEach(e => {
        e.checked = true;
        data.checked.push(e);
      });
    } else {
      data.stage.forEach(e => {
        e.checked = false;
      });
    }
    data.indeterminate = false;
  }

  changeResource(data, index) {
    data.stage[index].checked = !data.stage[index].checked;
    data.checked = [];
    data.checked = data.stage.filter(e => {
      return e.checked === true;
    });
    data.indeterminate = !!data.checked.length && data.checked.length < this.resourcelist.length;
    data.checkAll = data.checked.length === this.resourcelist.length;
  }

  change(data) {
    data.checked = !data.checked;
  }

  async submit() {
    try {
      let dataPermissionIdList: any[] = [];
      this.companyState.forEach((e, index) => {
        if (e.stage) {
          e.stage.forEach(e => {
            if (e.checked && e.checked === true) {
              dataPermissionIdList.push(e.id);
            }
          });
        }
      });
      this.resourceType.forEach(e => {
        if (e.stage) {
          e.stage.forEach(e => {
            if (e.checked && e.checked === true) {
              dataPermissionIdList.push(e.id);
            }
          });
        }
      });
      this.fileType.forEach(e => {
        if (e.allType) {
          let tmp = e.allType;
          Object.keys(this.fileTypeAllType).forEach(key => {
            if (tmp[key] && tmp[key].checked && tmp[key].checked === true) {
              dataPermissionIdList.push(tmp[key].id);
            }
          });
        }
      });
      this.fundfileType.forEach(e => {
        if (e.authType) {
          e.authType.forEach(e => {
            if (e.checked && e.checked === true) {
              dataPermissionIdList.push(e.id);
            }
          });
        }
      });
      this.fundStructure.forEach(e => {
        if (e.authType) {
          e.authType.forEach(e => {
            if (e.checked && e.checked === true) {
              dataPermissionIdList.push(e.id);
            }
          });
        }
      });
      this.fileCollectData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.fileRetrievalData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.companyCurrencyData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.companyTeamData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.financingStageData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.lpdataRangeData.forEach(e => {
        if (e.checked && e.checked === true) {
          dataPermissionIdList.push(e.id);
        }
      });
      this.loading = true;
      const res = await saveDataPermission({ roleId: this.roleId, dataPermissionIds: dataPermissionIdList.join(',') });
      this.loading = false;
      if (res.code === 200) {
        this.$message.success('保存成功');
      }
    } catch (err) {
      console.log(err);
    }
  }
}
export default DataPower;
